import React, { useState, useEffect, useRef } from 'react';
import {
  CustomIconBtn,
  DropdownContainer,
  List,
  PopUpContent,
  PopUpFooter,
  PopUpInputText,
  PopUpSavedFiltersContainer,
  PopupContainer,
  SavedFilterText
} from './index.element';
import { Checkbox } from 'components';
import { tanStackTableMultiFilterOption } from 'reducers/tanStackTable';
import { IcoFilter } from 'icons/indexed-icons/IcoFilter';
import theme from 'themes';

interface AdvanceFilterPopUpProps {
  options?: tanStackTableMultiFilterOption[];
  handleOptionSelect?: (option: AdvanceFilterOptionType[]) => void;
  searchable?: boolean;
  searchInputValue?: (input?: string) => void;
  selectedOpt?: string | JSX.Element;
  label?: JSX.Element;
  iconColor?: string;
}

export interface AdvanceFilterOptionType {
  name: string;
  value?: string | number;
  label?: string;
}

const AdvanceStatusFilterPopUp: React.FC<AdvanceFilterPopUpProps> = ({
  options,
  handleOptionSelect
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filterOption, setFilterOption] = useState(options);
  const dropdownRef = useRef<HTMLDivElement>(null); // Ref for the dropdown container

  // Function to toggle the dropdown visibility
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  // Effect to handle clicks outside the dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    // Add event listener when the component mounts
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
    handleOptionSelect && handleOptionSelect(selectedValues);
  }, [selectedValues]);

  // Handle checkbox changes
  const handleCheckboxChange = (event, data) => {
    const { checked } = event.target;
    setSelectedValues((prevSelectedValues) => {
      if (checked) {
        // Add value to the list if checked
        return [...prevSelectedValues, data];
      } else {
        // Remove value from the list if unchecked
        return prevSelectedValues.filter((item) => item?.value !== data?.value);
      }
    });
  };

  return (
    <>
      <DropdownContainer ref={dropdownRef}>
        <CustomIconBtn isActive={isOpen} onClick={toggleDropdown}>
          <IcoFilter width="16" height="16" />
        </CustomIconBtn>
        {isOpen && (
          <PopupContainer top="2rem">
              {filterOption &&
                filterOption.map((panel) => {
                  return (
                    <>
                      <PopUpSavedFiltersContainer>
                        <SavedFilterText>{panel?.category}</SavedFilterText>
                      </PopUpSavedFiltersContainer>
                    <List key={panel?.category}>
                      
                      {panel?.filters.map((item) => {
                        return (
                          <PopUpContent htmlFor={`checkbox-${item?.value}`}>
                            <Checkbox
                              width={20}
                              height={20}
                              label=""
                              checked={
                                !!selectedValues?.find((user) => user?.value === item?.value)
                              }
                              onChange={(e) =>
                                handleCheckboxChange(e, {
                                  name: panel?.category,
                                  value: item?.value
                                })
                              }
                              id={item?.value}
                            />
                            <PopUpInputText>{item.label}</PopUpInputText>
                          </PopUpContent>
                        );
                      })}
                    </List>
                    </>
                  );
                })}
            <PopUpFooter>
              <div style={{ display: 'flex', gap: '1rem' }}>
                <p style={{ color: theme.colors.lightGrey8 }} onClick={() => setSelectedValues([])}>
                  Clear
                </p>
                <p style={{ color: theme.colors.primaryBlue5 }} onClick={() => setIsOpen(!isOpen)}>
                  Apply
                </p>
              </div>
            </PopUpFooter>
          </PopupContainer>
        )}
      </DropdownContainer>
    </>
  );
};

export default AdvanceStatusFilterPopUp;